var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Consulta Control Baja Cliente")])], 1),
      _c("v-divider"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateStart.label,
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateStart, "value", $$v)
                      },
                      expression: "formFields.dateStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: _vm.formFields.dateEnd.label,
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                      },
                      expression: "formFields.dateEnd.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu",
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "max-width": "290px",
                        "min-width": "290px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        label: _vm.formFields.tramo.label,
                                        "prepend-icon": "event",
                                        clearable: "",
                                        readonly: ""
                                      },
                                      model: {
                                        value: _vm.formFields.tramo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tramo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.tramo.value"
                                      }
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.menu,
                        callback: function($$v) {
                          _vm.menu = $$v
                        },
                        expression: "menu"
                      }
                    },
                    [
                      _c(
                        "v-date-picker",
                        {
                          attrs: {
                            locale: "es-cl",
                            type: "month",
                            scrollable: ""
                          },
                          on: {
                            change: function($event) {
                              _vm.menu = false
                            }
                          },
                          model: {
                            value: _vm.formFields.tramo.value,
                            callback: function($$v) {
                              _vm.$set(_vm.formFields.tramo, "value", $$v)
                            },
                            expression: "formFields.tramo.value"
                          }
                        },
                        [_c("v-spacer")],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.motivo.label,
                      items: _vm.motivos,
                      "item-text": "motiname",
                      "item-value": "motiid",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.motivo.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.motivo, "value", $$v)
                      },
                      expression: "formFields.motivo.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.estado.label,
                      items: _vm.estados,
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.estado.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.estado, "value", $$v)
                      },
                      expression: "formFields.estado.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs3: "", sm3: "", md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.cliente.label,
                      items: _vm.clientes,
                      "item-text": "nombre",
                      "item-value": "id",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.cliente.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cliente, "value", $$v)
                      },
                      expression: "formFields.cliente.value"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs3: "", sm3: "", md3: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-sm-center botones-filtros mt-1" },
                  [
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.filtrar()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("search")
                        ]),
                        _vm._v("Filtrar\n          ")
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.clearFilters()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("clear")
                        ]),
                        _vm._v("Limpiar")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c("v-flex", { attrs: { xs6: "", sm6: "", md6: "" } }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs2: "", sm2: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionExportar.visible
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.exportarExcel()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c("div", { staticClass: "controlBajaCliente" }, [
        _c(
          "div",
          { staticClass: "gridcard rounded-card" },
          [
            _c("MantenedorGrid", {
              staticClass: "ag-theme-material",
              attrs: { gridOptions: _vm.gridOptions }
            })
          ],
          1
        )
      ]),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleEvidencia" }, [
                        _c("h2", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("Reporte Solicitado")
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.showModalDetalle
        ? _c("VerDetalle", {
            attrs: {
              editedItem: _vm.editedItem,
              editedItemCliente: _vm.editedItemCliente
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }